/*
const files = require.content('.', false, /\.js$/)
const modules = {}

files.keys().forEach(key=>{
  if(key === './index.js') {
    return
  }

  modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default
})

export default modules
*/

import app from './app'
import event from './event'
import coupon from './coupon'
import merchant from './merchant'

export default {
  app,
  event,
  coupon,
  merchant
}



// WEBPACK FOOTER //
// ./src/store/modules/index.js